import createJobOverview from "./ajaxJobFinder";
const setupJobFinderFilterObserver = () => {
    const allFilterBoxes = document.querySelectorAll('.ume-career-category-filter');

    let observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-filter') {
                let filterType = mutation.target.getAttribute('data-filter-type');
                let content = mutation.target.getAttribute('data-filter');
                if(content !== ''){
                    let superElement =  document.querySelector('[data-filter-type="super"]');
                    let contentSuper = superElement ? superElement.getAttribute('data-filter') : '';
                    let mainFilterElement = null;
                    if(contentSuper !== ''){
                        let mainFilterElementParent = document.querySelector(`[data-parent-name="${contentSuper.replace(/\s/g, '')}"]`);
                        if(mainFilterElementParent !== null){
                            mainFilterElement = mainFilterElementParent.querySelector('[data-filter-type="main"]');
                        }

                    }
                    let contentMain = mainFilterElement ? mainFilterElement.getAttribute('data-filter') : '';
                    let subFilterElement = null
                    if(contentMain !== ''){
                        let subFilterElementParent = document.querySelector(`[data-filter-target="${contentMain}"]`);
                        if(subFilterElementParent !== null){
                            subFilterElement = subFilterElementParent.querySelector('[data-filter-type="sub"]');
                        }
                    }
                    let contentSub = subFilterElement ? subFilterElement.getAttribute('data-filter') : ''
                    switch (filterType) {
                        case 'super':
                            createJobOverview(content, contentMain,  contentSub);
                            handleHistoryUpdate(content, contentMain, contentSub);
                            break;
                        case 'main':
                            createJobOverview(contentSuper, content, contentSub);
                            handleHistoryUpdate(contentSuper, content, contentSub);
                            break;
                        case 'sub':
                            createJobOverview(contentSuper, contentMain, content);
                            handleHistoryUpdate(contentSuper, contentMain, content);
                            break;
                    }
                }

            }
        })
    })

    allFilterBoxes.forEach(filterBox => {
        observer.observe(filterBox, {
            attributes: true
        })
    })
    function handleHistoryUpdate (filterSuper, filterMain, filterSub){
            let string = '';
            if(filterSuper !== ''){
                string = '?super=' + encodeURIComponent(filterSuper);
            }
        if(filterMain !== ''){
            string += '&main=' + encodeURIComponent(filterMain);
        }
        if(filterSub !== ''){
            string += '&sub=' + encodeURIComponent(filterSub);
        }
        if(string !== '' && window.location.href.indexOf('job-finder') > -1){
            window.history.pushState({}, document.title, '/job-finder/'+string);
        }

    }
}
export default setupJobFinderFilterObserver;